// src/App.tsx
import React, { useEffect } from "react";
import "./gangadhar.css";

const Gangadhar = () => {
  useEffect(() => {
    document.title = "Gangadhar Jami | Aditya University"
  }, [])
  return (
    <div className="gj-portfolio">
      {/* HERO SECTION */}
      <section className="gj-hero">
        <div className="gj-container gj-hero-content">
          <div className="gj-hero-text">
            <div className="gj-hero-top">
              <div className="gj-hero-avatar-wrapper">
                <img
                  src="https://adityauniversity.in/adtppu/SDG/gangadhar.JPG"
                  alt="Gangadhar Jami"
                  className="gj-hero-avatar"
                />
              </div>
              <div className="gj-hero-top-text">
                <p className="gj-hero-kicker">Web & Mobile Application Developer</p>
                <h1 className="gj-hero-title">Gangadhar Jami</h1>
                <p className="gj-hero-tagline">
                  B.Tech, Aditya University · Full Stack Developer · Technical Hub
                </p>
              </div>
            </div>

            <p className="gj-hero-subtitle">
              Full Stack Developer at{" "}
              <span className="gj-highlight">Technical Hub</span>, building
              scalable web and mobile applications with{" "}
              <span className="gj-highlight">React, Node.js, and Cloud</span>.
            </p>
            <p className="gj-hero-subtitle">
              Passionate about developing solutions for{" "}
              <span className="gj-highlight">education, automation, and AI</span>,
              and contributing to the digital transformation journey of{" "}
              <span className="gj-highlight">Aditya University</span>.
            </p>

            <div className="gj-hero-actions">
              <a href="#projects" className="gj-btn gj-btn-primary">
                View Projects
              </a>
              <a href="#contact" className="gj-btn gj-btn-outline">
                Contact
              </a>
            </div>
          </div>

          <div className="gj-hero-card">
            <div className="gj-hero-card-inner">
              <p className="gj-hero-role">Full Stack Developer</p>
              <p className="gj-hero-org">Technical Hub, Aditya Group</p>
              <p className="gj-hero-location">Kakinada, Andhra Pradesh, India</p>
              <div className="gj-hero-badges">
                <span className="gj-badge">React & React Native</span>
                <span className="gj-badge">Cloud & DevOps</span>
              </div>
              <p className="gj-hero-status">
                Available for{" "}
                <span className="gj-highlight">institutional projects</span>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ABOUT SECTION */}
      <section className="gj-section" id="about">
        <div className="gj-container">
          <div className="gj-section-header">
            <span className="gj-section-chip">Profile</span>
            <h2 className="gj-section-title">About</h2>
          </div>

          <div className="gj-grid-2">
            <p className="gj-text">
              I am a <strong>Full Stack Developer</strong> with hands-on
              experience in building production-ready applications for
              education, automation, and business workflows. At{" "}
              <strong>Technical Hub</strong>, I work on end-to-end solutions
              including frontend, backend, cloud deployment, and integrations
              with external services.
            </p>
            <p className="gj-text">
              My work focuses on providing <strong>reliable, secure, and
                scalable</strong> platforms for students, faculty, and
              administrators. I actively explore{" "}
              <strong>React, React Native, Node.js, MongoDB, AWS, Firebase, and
                AI integrations</strong> to deliver modern, user-centric
              experiences aligned with the vision of{" "}
              <strong>Aditya University</strong>.
            </p>
          </div>

          <div className="gj-info-grid">
            <div className="gj-info-item">
              <span className="gj-info-label">Role</span>
              <span className="gj-info-value">Full Stack Developer</span>
            </div>
            <div className="gj-info-item">
              <span className="gj-info-label">Department / Unit</span>
              <span className="gj-info-value">Technical Hub</span>
            </div>
            <div className="gj-info-item">
              <span className="gj-info-label">Expertise</span>
              <span className="gj-info-value">
                Web, Mobile, Cloud, Automation, AI Integration
              </span>
            </div>
            <div className="gj-info-item">
              <span className="gj-info-label">Location</span>
              <span className="gj-info-value">
                Kakinada District, Andhra Pradesh, India
              </span>
            </div>
          </div>
        </div>
      </section>

      {/* SKILLS SECTION */}
      <section className="gj-section gj-section-alt" id="skills">
        <div className="gj-container">
          <div className="gj-section-header">
            <span className="gj-section-chip">Tech Stack</span>
            <h2 className="gj-section-title">Technical Skills</h2>
          </div>

          <div className="gj-skills-grid">
            <div className="gj-skill-card">
              <h3>Frontend</h3>
              <p>
                React.js, Next.js, TypeScript, JavaScript (ES6+), HTML5, CSS3,
                Tailwind, Material-UI.
              </p>
            </div>
            <div className="gj-skill-card">
              <h3>Backend & APIs</h3>
              <p>Node.js, Express.js, REST APIs, Authentication, JWT.</p>
            </div>
            <div className="gj-skill-card">
              <h3>Databases</h3>
              <p>MongoDB, MySQL / SQL, Firebase Firestore.</p>
            </div>
            <div className="gj-skill-card">
              <h3>Mobile & Cross-Platform</h3>
              <p>React Native, Expo, Android basics.</p>
            </div>
            <div className="gj-skill-card">
              <h3>Cloud & DevOps</h3>
              <p>AWS (EC2, S3, Route 53), Linux servers, Nginx, PM2.</p>
            </div>
            <div className="gj-skill-card">
              <h3>Additional</h3>
              <p>Git & GitHub, WebSockets, IoT Integrations, Basic Cybersecurity.</p>
            </div>
          </div>
        </div>
      </section>

      {/* PROJECTS SECTION */}
      <section className="gj-section" id="projects">
        <div className="gj-container">
          <div className="gj-section-header">
            <span className="gj-section-chip">Work</span>
            <h2 className="gj-section-title">Selected Projects</h2>
          </div>

          <p className="gj-section-intro">
            A few projects that demonstrate my ability to build practical
            solutions for academic and industry use-cases.
          </p>

          <div className="gj-projects-grid">
            <article className="gj-project-card">
              <h3>Bus In/Out Dashboard</h3>
              <p className="gj-project-meta">
                React · Chart.js · Node.js · REST API · AWS
              </p>
              <p className="gj-text">
                A real-time dashboard to monitor bus in/out timings, weekly
                reports, and student movement patterns. Designed for
                institution-level visibility with charts, filters, and export
                options for administration.
              </p>
              <ul className="gj-project-list">
                <li>Interactive bar, pie and line charts for daily/weekly data.</li>
                <li>API integration with existing backend services.</li>
                <li>Built to be extendable for other campus transport analytics.</li>
              </ul>
            </article>

            <article className="gj-project-card">
              <h3>Placement Management Portal</h3>
              <p className="gj-project-meta">
                React · Node.js · MongoDB · Authentication
              </p>
              <p className="gj-text">
                A web application to streamline placement activities including
                student registrations, company requirements, eligibility
                tracking, and placement reports for the training & placement
                department.
              </p>
              <ul className="gj-project-list">
                <li>Automated eligibility and status tracking.</li>
                <li>Role-based access for students, coordinators, and admins.</li>
                <li>Downloadable and visual placement reports.</li>
              </ul>
            </article>

            <article className="gj-project-card">
              <h3>3D AI Avatar Chatbot (Prototype)</h3>
              <p className="gj-project-meta">
                React · Three.js / 3D · API Integration
              </p>
              <p className="gj-text">
                A prototype of a 3D AI-powered assistant intended to guide
                students through college information, placements, and FAQs,
                with potential integration into Aditya’s digital portals.
              </p>
              <ul className="gj-project-list">
                <li>3D avatar rendering in a browser.</li>
                <li>Conversational AI backend using large language models.</li>
                <li>Designed for integration with existing React websites.</li>
              </ul>
            </article>
          </div>
        </div>
      </section>

      {/* CERTIFICATIONS SECTION */}
      <section className="gj-section gj-section-alt" id="certifications">
        <div className="gj-container">
          <div className="gj-section-header">
            <span className="gj-section-chip">Credentials</span>
            <h2 className="gj-section-title">Certifications & Achievements</h2>
          </div>

          <ul className="gj-list">
            <li>
              AWS Certified Cloud Practitioner – Demonstrating cloud
              fundamentals and deployment understanding.
            </li>
            <li>
              Hands-on experience with real-time projects at Technical Hub
              (AI, Cloud, Web, and IoT).
            </li>
            <li>
              Actively involved in building internal tools and platforms that
              support students and faculty.
            </li>
          </ul>
        </div>
      </section>

      {/* CONTACT SECTION */}
      <section className="gj-section" id="contact">
        <div className="gj-container">
          <div className="gj-section-header">
            <span className="gj-section-chip">Reach Out</span>
            <h2 className="gj-section-title">Contact</h2>
          </div>

          <p className="gj-section-intro">
            For collaborations, internal projects, or technical initiatives at
            Aditya University, feel free to reach out.
          </p>

          <div className="gj-contact-grid">
            <div className="gj-contact-item">
              <span className="gj-info-label">Email</span>
              <a
                className="gj-link"
                href="mailto:gangadhar.j@adityauniversity.in"
              >
                gangadhar.j@adityauniversity.in
              </a>
            </div>
            <div className="gj-contact-item">
              <span className="gj-info-label">Phone</span>
              <a className="gj-link" href="tel:+917396376944">
                +91-7396376944
              </a>
            </div>
            <div className="gj-contact-item">
              <span className="gj-info-label">Portfolio</span>
              <a
                className="gj-link"
                href="https://gangadhar.jami.ltd"
                target="_blank"
                rel="noreferrer"
              >
                gangadhar.jami.ltd
              </a>
            </div>
            <div className="gj-contact-item">
              <span className="gj-info-label">LinkedIn</span>
              <a
                className="gj-link"
                href="https://www.linkedin.com/in/gangadhar-jami-80930026a"
                target="_blank"
                rel="noreferrer"
              >
                linkedin.com/in/gangadhar-jami
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Gangadhar;
